"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _checkmark = _interopRequireDefault(require("../../../core/checkmark"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _buttonGroup = _interopRequireDefault(require("../../../core/button-group"));
var _editableField = _interopRequireDefault(require("../../../core/editable-field"));
var _setEntryRtcs = _interopRequireDefault(require("./entry-action-buttons/set-entry-rtcs"));
var _emailActions = _interopRequireDefault(require("./entry-action-buttons/email-actions"));
var _editEntry = _interopRequireDefault(require("./entry-action-buttons/edit-entry"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Several of the tabs within the manage entries section have a table of entries
// Although the entries may be of different types and therefore have some different actions for each row
// many of the columns are common to all entries.
// This section provides the part of the row that is common to all entries regardless of type.
const today = new Date().toISOString().split('T')[0];
var _ref = /*#__PURE__*/_react.default.createElement("span", null, "Paddler Promoted");
class EntriesTableRow extends _react.Component {
  constructor(...args) {
    super(...args);
    // TODO times are stored as UTC but we probably need to consider BST
    // Also not that confident of this function.
    _defineProperty(this, "_displayDateTime", value => {
      if (!value) return '';
      const datePart = value.split('T')[0];
      const timePart = value.split('T')[1].split('.')[0];
      return (0, _occasion.default)(datePart, 'D MMM') + ' ' + timePart.substring(0, 5);
    });
    _defineProperty(this, "_onChange", (field, value) => {
      this.props.onUpdateEntry(this.props.entry.id, field, value);
    });
    _defineProperty(this, "_getPromotionText", entry => {
      // only display promotion flag if promotion is before the race or we don't know when it happened
      // and race in future
      if (!entry.promotion || entry.promotion.dateOfPromotion && entry.promotion.dateOfPromotion >= entry.race.competitionDay.dayDate || !entry.promotion.dateOfPromotion && entry.race.competitionDay.dayDate < today) {
        return null;
      }
      if (!entry.promotion.dateOfPromotion) {
        return _ref;
      }
      const dateString = (0, _occasion.default)(entry.promotion.dateOfPromotion, 'D MMM');
      return /*#__PURE__*/_react.default.createElement("span", null, entry.promotion.promotedToBibID > 0 ? 'Paddler Promoted on ' : 'Pending Promotion from ', dateString);
    });
  }
  render() {
    const entry = this.props.entry;
    const clashText = entry.clashesWith ? 'Paddler also in ' + entry.clashesWith : null;
    const promotionText = this._getPromotionText(entry);
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: entry.canEnterFromWaitingList && entry.entryStatusRef === 'WAIT' ? 'table-warning' : ''
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editEntry.default, {
      entry: entry,
      useFreeCode: this.props.useFreeCode
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_buttonGroup.default, {
      style: {
        paddingLeft: 0,
        minWidth: '2rem'
      }
    }, !promotionText ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "danger",
      style: {
        paddingRight: '0.2rem',
        paddingLeft: '0.2rem'
      },
      size: "sm",
      title: promotionText
    }, "P"), !clashText ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: entry.competitionDivision.excludesEntriesInAnotherRace ? 'warning' : 'success',
      size: "sm",
      style: {
        paddingRight: '0.2rem',
        paddingLeft: '0.2rem'
      },
      title: clashText
    }, "!!"))), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, this._displayDateTime(entry.entrySortDate)), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, (0, _occasion.default)(entry.race.competitionDay.dayDate, 'ddd')), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entry.rankingDivisionDescription, entry.race.isMultiClass ? ' ' + entry.classDescription : '', !entry.competitionDivision.isRanking && entry.bibNumber ? ' Bib ' + entry.bibNumber : ''), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: !entry.bibNumber || !entry.competitionDivision.isRanking,
      value: entry.startListBib,
      onChange: this._onChange.bind(this, 'startListBib'),
      type: "Integer",
      name: "startListBib",
      required: true,
      className: "text-xs-right"
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entry.bibName), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-center"
    }, entry.ageCategory.description), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entry.entryText), !this.props.useFreeCode ? null : /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      value: entry.freeCode,
      onChange: this._onChange.bind(this, 'freeCode'),
      type: "text",
      name: "freeCode",
      maxLength: 5
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_emailActions.default, {
      entry: entry,
      onChangeContactEmail: this._onChange.bind(this, 'contactEmail')
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      name: "isLateEntry",
      checked: entry.isLateEntry,
      onChange: this._onChange.bind(this, 'isLateEntry'),
      enabled: !entry.isOnlineEntry
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center read-only"
    }, /*#__PURE__*/_react.default.createElement(_checkmark.default, {
      checked: entry.isOnlineEntry
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      name: "hasPaid",
      checked: entry.hasPaid,
      onChange: this._onChange.bind(this, 'hasPaid'),
      enabled: !entry.isOnlineEntry
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, entry.entryTypeDescription), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_setEntryRtcs.default, {
      entry: entry,
      onChangeNotes: this._onChange.bind(this, 'rtcNotes')
    }), ' '), this.props.children);
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EntriesTableRow, "partialQueries", {
  Entry: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    id: true,
    bibNumber: true,
    startListBib: true,
    bibName: true,
    entryText: true,
    isOnlineEntry: true,
    entrySortDate: true,
    canEnterFromWaitingList: true,
    freeCode: true,
    entryTypeDescription: true,
    entryStatusRef: true,
    entryStatusDescription: true,
    isLateEntry: true,
    hasPaid: true,
    ageCategory: {
      description: true
    },
    classDescription: true,
    rankingDivisionDescription: true,
    clashesWith: true,
    competitionDivision: {
      description: true,
      isRanking: true,
      excludesEntriesInAnotherRace: true
    },
    race: {
      isMultiClass: true,
      raceName: true,
      competitionDay: {
        dayDate: true
      }
    },
    promotion: {
      promotedToBibID: true,
      dateOfPromotion: true
    }
  }, _setEntryRtcs.default.partialQueries.Entry), _emailActions.default.partialQueries.Entry), _editEntry.default.partialQueries.Entry)
});
var _default = exports.default = (0, _reactBicycle.connect)(EntriesTableRow, undefined, (client, props) => ({
  onUpdateEntry(id, field, value) {
    return client.update('Entry.set', {
      id,
      field,
      value
    });
  }
}));